import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-page-svg',
    templateUrl: './page-svg.component.html',
    styleUrls: ['./page-svg.component.scss'],
})
export class PageSvgComponent {}
